import * as Yup from 'yup';
import { PqrTimeDate } from '../../../../../../shared/types/paramPqrTimes';

export const initialValues: PqrTimeDate = {
    typeSacTime: '',
    typeClassificationSacTime: '',
    sacTime: '',
    typeFuragTime: '',
    typeClassificationFuragTime: '',
    furagTime: '',
};

export const validationSchema = Yup.object({
    typeClassificationSacTime: Yup.string().required(
        'La Certificación es obligatorio'
    ),
    sacTime: Yup.string().required('El Número de Días es obligatorio'),
    typeClassificationFuragTime: Yup.string().required(
        'La Certificación es obligatorio'
    ),
    furagTime: Yup.string().required('El Número de Días es obligatorio'),
});
